/* ERA v6 · Menu burger mobile (N1) : fermeture au voile / Échap, libellé du bouton */
(() => {
  if (window.__e6mMenu) return;
  window.__e6mMenu = true;

  const getMenu = () => {
    const nav = document.querySelector('.header__mobile-menu > .e6m');
    return nav ? nav.parentElement : null;
  };
  const sync = (menu) => {
    const t = menu.querySelector(':scope > summary');
    if (t) t.setAttribute('aria-label', menu.open ? 'Fermer le menu' : 'Ouvrir le menu');
  };
  const close = (menu) => { menu.open = false; sync(menu); };

  // Le voile est un ::after du <body> : tout clic hors du menu ouvert le ferme.
  document.addEventListener('click', (e) => {
    const menu = getMenu();
    if (!menu || !menu.open) return;
    if (menu.contains(e.target)) {
      if (e.target.closest('.e6m a')) setTimeout(() => close(menu), 0);
      return;
    }
    e.preventDefault();
    close(menu);
  }, true);

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const menu = getMenu();
    if (!menu || !menu.open) return;
    close(menu);
    const t = menu.querySelector(':scope > summary');
    if (t) t.focus();
  });

  document.addEventListener('toggle', (e) => {
    const menu = getMenu();
    if (menu && e.target === menu) sync(menu);
  }, true);

  // Fermé quand on revient en arrière sur une page mise en cache (bfcache)
  window.addEventListener('pageshow', () => { const m = getMenu(); if (m && m.open) close(m); });
})();
